<template>
  <div class="row">
    <div class="col-12 text-center">
      <div class="text-center">
        <img
          src="@/assets/img/regular-unlink.svg"
          alt="regular-unlink"
          class="img-box text-center"
        />
      </div>
      <div>
        <span class="d-block desc-label">
          Al momento el estudiante no contiene Análisis de Elegibilidad para
          mostrar
        </span>
        <b>Favor de presionar el botón de añadir para continuar</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddAnalysisEgibilityBox',
};
</script>

<style scoped>
.img-box {
  margin-top: 100px;
  margin-bottom: 50px;
}

.desc-label {
  text-align: center;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
  width: 100%;
}

.press-label {
  text-align: center;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #727272;
  width: 100%;
}
</style>
